/* eslint-disable no-unused-vars */
import {apolloClient} from "@/setup/apollo-setup";

// import * as generic from "@/store/generic/mutations/result-status.js";

import Detail from "./student-enroll-detail.js";

import {
  GET_STUDENTENROLL_LIST,
  GET_STUDENT_ENROLL_BY_CURRENT_USER,
  GET_STUDENT_ENROLL_BYID,
} from '@/queries/modules/student-enroll/student-enroll.js';
import {getField, updateField} from "vuex-map-fields";

const state = {
  studentEnroll: {
    id: '',
    enrollNo: '',
    academicPeriodId: '',
    periodCode: '',
    studentId: '',
    studentCode: '',
    enrollDate: '',
    totalCredit: null,
    totalDropCredit: null,
    studentEnrollDetails: [],
    source: '',
  },
  studentEnrolls: [],
  processing: false,
  error: null,
  success: null,
};

const getters = {
  getField
};

const mutations = {
  updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
  setStudentEnroll: (state, payload) => {
    state.studentEnroll = payload;
  },
  setStudentEnrolls: (state, payload) => {
    state.studentEnrolls = payload;
  },
};

const actions = {

  async getStudentEnrollsByCurrentUser({commit}) {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_STUDENT_ENROLL_BY_CURRENT_USER,
          fetchPolicy: 'network-only',
          context: { clientName: 'Prisma2' }
        })
      const {data} = await result;

      commit('setProcessing', false);
      // commit('setStudentEnrolls', data.getStudentEnrollsByCurrentUser);
      return data.getStudentEnrollsByCurrentUser;

    } catch (e) {
      commit('setError', e);
      return null;
    }
  },
  async getStudentEnrollsById({commit}, payload) {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_STUDENT_ENROLL_BYID,
          variables: payload,
          fetchPolicy: 'network-only',
          context: { clientName: 'Prisma2' }
        })
      const {data} = await result;

      commit('setProcessing', false);
      // commit('setStudentEnrolls', data.getStudentEnrollsByCurrentUser);
      return data.getStudentEnroll;

    } catch (e) {
      commit('setError', e);
      return null;
    }
  },
  async getStudentEnrollList({commit}) {
    // commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_STUDENTENROLL_LIST,
          fetchPolicy: 'network-only',
          context: { clientName: 'Prisma2' }
        })
      const {data} = await result;

      // TODO: Handle after success;
      return {status: {success: true, error: false, message: ""}, data: [...data.getStudentEnrolls]};

    } catch (e) {
      // console.log(e);
      // commit('setError', error(e));
      return {status: {success: false, error: true, message: "", full: e}};
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    Detail
  }
}
